<template>
	<div class="active-code border-rd-8 bg-color-light position-rel">
		<div class="spinner-box" v-if="loading">
			<div class="spinner-box__wrap display-flex-center justify-content-center full-box">
				<b-spinner class="" variant="primary" label="Text Centered"></b-spinner>
			</div>
		</div>
		<div class="active-code__wrap">
			<h3 class="active-code__title font-size-24 font-sanpro-semibold primary-color-txt">Kích hoạt sách</h3>
			<div class="active-code__desc active-code__desc--experience primary-color-txt" v-if="isAccExperience">
				<p>Đăng ký / Đăng nhập để kích hoạt và sử dụng đầy đủ tính năng.</p>
				<p>Kích hoạt mã cào sau mỗi cuốn sách giáo khoa để mở miễn phí học liệu điện tử và toàn bộ tính năng hỗ trợ</p>
			</div>
			<template v-else>
				<div class="active-code__desc" v-if="isPopup">
					<div class="active-code__desc__content">
						<p class="secondary-color-txt margin-0">Bạn chưa kích hoạt sách này.</p>
						<p class="secondary-color-txt margin-0">Kích hoạt để sử dụng toàn bộ quyển sách và trải nghiệm các chức năng mở rộng.</p>
					</div>
					<a href="javascript:;" @click="openGuideModal" class="primary-color">Tìm hiểu thêm</a>
				</div>
				<div class="active-code__form">
					<p v-if="isLibraryPage" class="font-sanpro-light primary-color-txt">Kích hoạt mã cào sau mỗi cuốn sách giáo khoa để mở miễn phí học liệu điện tử và toàn bộ tính năng hỗ trợ</p>
					<label class="font-size-18 font-sanpro-semibold secondary-color-txt">Mã kích hoạt</label>
					<input class="form-control font-size-16 from-h30 border-rd-20 color_bg_gray_light" type="text" v-model.lazy="code" v-debounce="300" placeholder="Nhập mã kích hoạt vào đây" />
					<a href="javascript:;" @click="openGuideModal" class="font-sanpro-semibold primary-color readmore-popup display-block" v-if="isPopup">
						Tìm hiểu mã kích hoạt
					</a>
				</div>
				<div class="active-code__preview display-flex-center justify-content-center" v-if="previewBook">
					<div class="list__box__body margin-0 p-0" v-if="dataBook">
						<ItemBook :itemBook="dataBook" />
					</div>
					<p v-else class="active-code__intro text-center margin-0 font-size-24 font-sanpro-semibold secondary-color-txt">{{ code && findNotBook ? 'Không tìm thấy sách theo mã trên' : 'Nhập mã kích hoạt để hiển thị sách' }}</p>
				</div>
			</template>
			<div class="active-code__action display-flex-center" :class="{'justify-content-between': !isPopup, 'justify-content-end': isPopup}">
				<a href="javascript:;" @click="openGuideModal" class="font-sanpro-semibold primary-color" v-if="!isPopup">
					Tìm hiểu mã kích hoạt
				</a>
				<div class="active-code__btns" v-if="!isAccExperience">
					<a href="javascript:;" class="primary-color font-sanpro-semibold" v-if="isPopup" @click="cancleActive">Hủy</a>
					<button type="button" class="btn btn-gray btn-pointer-evt-none css-atvd font-size-16 border-rd-20 secondary-color-txt font-sanpro-medium actived" v-if="dataBook && dataBook.actived">
	                  <img src="@/assets/images/active.png" alt="Đã kích hoạt"> 
	                  Đã kích hoạt
	                </button>
	                <button v-else-if="!dataBook || !dataBook.actived" type="button" class="btn btn-main border-rd-20 font-size-16 font-sanpro-semibold" @click="handleActiceBook">
						Kích hoạt
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ItemBook from './../ebooklist/ItemBook.vue'
	import { getBookByCode, activeBook } from './../../_api/activecode'
	import { mapActions } from 'vuex'
	import debounce from "@/directives/debounce";

	export default {
		name: 'ActiveCode',
		props: {
			previewBook: Boolean,
			bookId: Number,
			isPopup: Boolean,
			isLibraryPage: Boolean,
			isAccExperience: Boolean
		},
		components: {
			ItemBook
		},
		directives: { debounce },
		data () {
			return {
				code: '',
				dataBook: null,
				loading: false,
				findNotBook: false,
				evtThrotting: false
			}
		},
		watch: {
			'code': 'getBookInfoByCode'
		},
		methods: {
			...mapActions('common', ['setToggleGuideActiveBook']),

			getBookInfoByCode() {
				let self = this;
				if(self.code && self.previewBook) {
					self.loading = true;
					self.dataBook = null;
					self.findNotBook = false;
					getBookByCode(self.code).then(res => {
						if(res && res.data && !res.errors) {
							self.dataBook = res.data;
						} else {
							self.findNotBook = true;
						}
					}).finally(() => self.loading = false);
				}
			},

			handleActiceBook() {
				let self = this;
				if(!self.code) {
					self.$toast.error('Bạn hãy nhập mã code');
				} else if (self.code && (!self.bookId && (!self.dataBook || !self.dataBook.bookId))) {
					self.$toast.error('Không tìm thấy sách cần kích hoạt');
				} else {
					let id = self.bookId ? self.bookId : self.dataBook.bookId;
					activeBook(self.code, id).then(res => {
						if(res && !res.errors) {
							self.$toast.success('Kích hoạt sách thành công');
							self.dataBook = null;
							self.code = '';
							self.$emit('activeSuccess', id);
						}
					}).finally(() => self.loading = false);
				}
			},

			cancleActive() {
				this.$emit('cancleActice', true);
			},

			getBookByCodeBlur() {
				if(window.innerWidth < 992 && this.code) {
					this.getBookByCode();
				}
			},

			openGuideModal() {
				this.setToggleGuideActiveBook(true);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./../../../../assets/scss/_variables";

	.active-code {
		box-shadow: 0px 0px 10px rgba($color_dark, .2);
		-webkit-box-shadow: 0px 0px 10px rgba($color_dark, .2);
		-moz-box-shadow: 0px 0px 10px rgba($color_dark, .2);
		width: 390px;

		&__wrap {
			padding: 18px 16px;
		}

		&__title, &__desc {
			margin-bottom: 15px;
		}

		&__desc {
			&__content {
				p {
					&:not(:last-child) {
						margin-bottom: 10px;
					}
				}
			}

			&--experience {
				p {
					@extend .position-rel;
					padding-left: 20px;

					&:before {
						content: "";
						width: 10px;
						height: 10px;
						@extend .border-rd-50;
						@extend .display-block;
						background: $primary_text_color;
						position: absolute;
						top: 4px;
						left: 0;
					}
				}
			}
		}

		&__form {
			margin-bottom: 20px;

			input {
				border: 1px solid $color_bg_gray_light;
				letter-spacing: 0.03em;
			}

			.readmore-popup {
				margin-top: 15px;
			}
		}

		&__preview {
			min-height: 270px;
			width: 210px;
			margin: 0 auto;
		}

		&__intro {
			line-height: 1.3;
		}

		&__action {
			margin-top: 25px;

			button {
				line-height: 1;
				padding: 0 20px;
			}
		}
		
		&__btns {
			.actived {
				padding: 3px 15px 5px;
				letter-spacing: 0.03em;

				img {
					max-width: 16px;
				}
			}

			>* {
				&:not(:last-child) {
					margin-right: 20px;
				}
			}
		}

		@media screen and ( max-width: 575px ) {
			width: 290px;

			&__wrap {
				padding: 15px 10px;
				text-align: left;
			}

			&__action {
				* {
					font-size: 15px;
				}

				button {
					padding: 0 15px;
				}
			} 
		}
	}
</style>